import React, { FC } from 'react';
import "./Loader.css";

interface LoaderProps{
  isDisabled?:boolean;
  isFullScreen?:boolean;
  className?:string;
}

const Loader : FC<LoaderProps> = ({
    isFullScreen,
    isDisabled,
    className,
}) => {

  return(
    <div className={`loader text-loader text-loader-big ${isFullScreen && "loader-full"} ${isDisabled && "loader-disabled"} ${className && className}`}>
        <div className="loader-inner">
            {/* <img src={process.env.PUBLIC_URL+"/svgs/time-saver-empty.svg"} alt="loader" /> */}
        </div>
    </div>
  );
}
export default Loader;